import React, { useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { BoxPlotController, BoxAndWiskers } from '@sgratzl/chartjs-chart-boxplot';

Chart.register(...registerables, BoxPlotController, BoxAndWiskers);

const BoxPlot = ({ displayData, hrvData, chartId, timePeriod, chartName }) => {
    const chartRef = useRef(null);
    let HRVValues = [];
    let valueLabel = '';
    let datasets = [];
    const dataPeriod = timePeriod === 'weekly' ? 'Week' : timePeriod === 'monthly' ? 'Month' : 'Quarter';
    let chartTitle = '';
    let prevMonthData = [];
    let chartLabels = [''];
    let yAxisMin = 0;

    if (chartName === 'quartileAnalysis') {
        const timePeriodIndex = timePeriod === 'weekly' ? 0 : timePeriod === 'monthly' ? 1 : 2;
        HRVValues = hrvData[timePeriodIndex].nocturnal_hrv.values;
        valueLabel = 'Nocturnal HRV';
        chartTitle = `HRV Distribution for the last ${dataPeriod}`;
        yAxisMin = Math.min(...HRVValues);
    } else if (chartName === 'advancedMetrics') {
        HRVValues = hrvData;
        valueLabel = 'Heart Rate';
        chartTitle = `Heart Rate Distribution and Metrics for the last ${dataPeriod}`;
        yAxisMin = Math.min(...HRVValues);
    } else if (chartName === 'monthlyTrends') {
        prevMonthData = displayData.nocturnal_hrv.values;
        HRVValues = hrvData[1].nocturnal_hrv.values;
        valueLabel = 'Nocturnal HRV'
        chartTitle = "HRV Comparison: Previous 30 Days vs Current Period";
        chartLabels = ['Previous 30 Days', 'Current Period'];
        yAxisMin = Math.min(...[Math.min(...prevMonthData), Math.min(...HRVValues)]);
    }

    if (chartName !== 'monthlyTrends') {
        datasets = [
            {
                label: valueLabel,
                data: [HRVValues],
                backgroundColor: 'rgba(66, 107, 179, 0.2)',
                borderColor: 'rgba(66, 107, 179, 1)',
                borderWidth: 2,
                barPercentage: 0.5,
                outlierColor: '999999',
                itemRadius: 5,
            }
        ];
    } else {
        datasets = [
            {
                label: valueLabel,
                data: [prevMonthData, HRVValues],
                backgroundColor: ['rgba(66, 107, 179, 0.2)', 'rgba(255, 99, 132, 0.2)'],
                borderColor: ['rgba(66, 107, 179, 1)', 'rgba(255, 99, 132, 1)'],
                borderWidth: 2,
                barPercentage: 0.5,
                outlierColor: '999999',
                itemRadius: 5,
            },
        ];
    }

    useEffect(() => {
        const ctx = chartRef.current.getContext('2d');

        const data = {
            labels: chartLabels,
            datasets: datasets
        };

        const config = {
            type: 'boxplot',
            data: data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: chartTitle
                    },
                    datalabels: {
                        display: false
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        min: yAxisMin
                    }
                }
            }
        };

        // Check if chart instance already exists to avoid creating multiple charts
        if (chartRef.current.chart) {
            chartRef.current.chart.destroy();  // Destroy the old chart before creating a new one
        }

        // Create new chart instance
        chartRef.current.chart = new Chart(ctx, config);
    }, []);

    return <canvas ref={chartRef} id={chartId} />
}

export default BoxPlot;